const ec2Status = `<?xml version="1.0" encoding="UTF-8"?>
<DescribeInstanceStatusResponse xmlns="http://ec2.amazonaws.com/doc/2016-11-15/">
    <requestId>5b506c7c-1e45-41bd-a2cf-806a8b54d5a3</requestId>
    <instanceStatusSet>
        <item>
            <instanceId>i-091b7f092a92e5faa</instanceId>
            <availabilityZone>us-east-1c</availabilityZone>
            <availabilityZoneId>use1-az2</availabilityZoneId>
            <operator>
                <managed>false</managed>
            </operator>
            <instanceState>
                <code>16</code>
                <name>running</name>
            </instanceState>
            <systemStatus>
                <status>ok</status>
                <details>
                    <item>
                        <name>reachability</name>
                        <status>passed</status>
                    </item>
                </details>
            </systemStatus>
            <instanceStatus>
                <status>ok</status>
                <details>
                    <item>
                        <name>reachability</name>
                        <status>passed</status>
                    </item>
                </details>
            </instanceStatus>
            <attachedEbsStatus>
                <status>ok</status>
                <details>
                    <item>
                        <name>reachability</name>
                        <status>passed</status>
                    </item>
                </details>
            </attachedEbsStatus>
        </item>
    </instanceStatusSet>
</DescribeInstanceStatusResponse>`

export default ec2Status;
